var map = {
	"./cs/acceptLogin.json": 22909,
	"./cs/account.json": 2547,
	"./cs/addNewContactsModal.json": 97607,
	"./cs/addNewIntegration.json": 43855,
	"./cs/addRole.json": 73723,
	"./cs/address.json": 10476,
	"./cs/addressFields.json": 91829,
	"./cs/addresses.json": 96328,
	"./cs/aiActions.json": 53181,
	"./cs/aiSettings.json": 50343,
	"./cs/aiWorkflows.json": 17048,
	"./cs/apiKeys.json": 15160,
	"./cs/appCatalog.json": 9950,
	"./cs/assetFinder.json": 79860,
	"./cs/bankAccount.json": 92529,
	"./cs/bankDetailsToast.json": 59823,
	"./cs/barcodeReader.json": 68451,
	"./cs/catalogImport.json": 62534,
	"./cs/catalogLastLog.json": 40944,
	"./cs/cataloge.json": 85638,
	"./cs/categories.json": 22608,
	"./cs/categoryModal.json": 44609,
	"./cs/channels.json": 96468,
	"./cs/characteristicsModal.json": 22103,
	"./cs/chart1.json": 63799,
	"./cs/collectionSettings.json": 25825,
	"./cs/companies.json": 65043,
	"./cs/companyEdit.json": 68823,
	"./cs/confirmModal.json": 94553,
	"./cs/contactsModal.json": 95630,
	"./cs/copyProducts.json": 98493,
	"./cs/countries.json": 66938,
	"./cs/couriersSettings.json": 8437,
	"./cs/crm.json": 8728,
	"./cs/crmItemFinder.json": 46067,
	"./cs/crmPaymentPairing.json": 22686,
	"./cs/crmPaymentPairingModal.json": 16779,
	"./cs/crmSettings.json": 12409,
	"./cs/currencies.json": 95735,
	"./cs/customRowModal.json": 44898,
	"./cs/customRows.json": 94030,
	"./cs/customerService.json": 49815,
	"./cs/datePicker.json": 51670,
	"./cs/defaultWebshops.json": 89458,
	"./cs/deliveredStatuses.json": 84618,
	"./cs/deliveries.json": 27808,
	"./cs/deliveriesModal.json": 19573,
	"./cs/deliveryCountriesSetting.json": 26934,
	"./cs/deliveryDetails.json": 96326,
	"./cs/deliveryStatusModal.json": 17999,
	"./cs/deliveryTrackingStatuses.json": 19988,
	"./cs/denyOrder.json": 17754,
	"./cs/domains.json": 77781,
	"./cs/editDeliveryModal.json": 29725,
	"./cs/editOnClick.json": 7659,
	"./cs/editOrderProductsModal.json": 52393,
	"./cs/editUser.json": 18715,
	"./cs/events.json": 18913,
	"./cs/externalCategoriesModal.json": 25024,
	"./cs/files.json": 11571,
	"./cs/filesModal.json": 35524,
	"./cs/filesWithLabel.json": 14995,
	"./cs/filters.json": 81887,
	"./cs/finance.json": 60334,
	"./cs/first.json": 26278,
	"./cs/forgottenPassword.json": 50843,
	"./cs/fraudRisk.json": 14921,
	"./cs/generalSettings.json": 24221,
	"./cs/global.json": 27579,
	"./cs/home.json": 64427,
	"./cs/imageEditor.json": 79292,
	"./cs/imageUpload.json": 96056,
	"./cs/incomeSettings.json": 68470,
	"./cs/incomeStatement.json": 20724,
	"./cs/incomingItemsStatuses.json": 85146,
	"./cs/incomingProducts.json": 21748,
	"./cs/incomingstatuses.json": 97806,
	"./cs/ingredients.json": 69976,
	"./cs/integrationAuth.json": 21124,
	"./cs/integrationSettingsModal.json": 23996,
	"./cs/integrations.json": 27967,
	"./cs/inventoryAnalytics.json": 37120,
	"./cs/invoice.json": 71343,
	"./cs/invoiceData.json": 15991,
	"./cs/invoiceDetails.json": 88031,
	"./cs/invoiceModal.json": 23720,
	"./cs/itemOperationPrints.json": 19060,
	"./cs/itemOperationTypes.json": 45789,
	"./cs/knowledgeBase.json": 20961,
	"./cs/labels.json": 90987,
	"./cs/languages.json": 58311,
	"./cs/leftSidebar.json": 7415,
	"./cs/lineOptions.json": 75672,
	"./cs/login.json": 63093,
	"./cs/manualIncoming.json": 35206,
	"./cs/manufacturingCollectList.json": 92736,
	"./cs/manufacturingDailyList.json": 48947,
	"./cs/manufacturingDesigner.json": 38431,
	"./cs/manufacturingGrant.json": 78796,
	"./cs/manufacturingMaterials.json": 95840,
	"./cs/manufacturingModal.json": 67639,
	"./cs/manufacturingOperationsModal.json": 29189,
	"./cs/manufacturingWorkstation.json": 21053,
	"./cs/menu.json": 87803,
	"./cs/messages.json": 90064,
	"./cs/meta.json": 10989,
	"./cs/modal.json": 18057,
	"./cs/nested.json": 75159,
	"./cs/newAssets.json": 22583,
	"./cs/newCustomer.json": 88862,
	"./cs/newManualIncoming.json": 9992,
	"./cs/newManufacturingOperation.json": 95909,
	"./cs/newMember.json": 61780,
	"./cs/newOutgoing.json": 33412,
	"./cs/newPartner.json": 85284,
	"./cs/newSale.json": 29733,
	"./cs/notifications.json": 71208,
	"./cs/oneByOneTable.json": 30981,
	"./cs/operationBoard.json": 92827,
	"./cs/operationPage.json": 24810,
	"./cs/order.json": 12356,
	"./cs/orderAfterStatus.json": 67888,
	"./cs/orderButtons.json": 77141,
	"./cs/orderChange.json": 62748,
	"./cs/orderMultiplePayment.json": 73330,
	"./cs/orderPayment.json": 9726,
	"./cs/orderProducts.json": 46912,
	"./cs/orderStatuses.json": 43434,
	"./cs/outgoing.json": 60758,
	"./cs/packingSettings.json": 65010,
	"./cs/page.json": 22711,
	"./cs/password.json": 78121,
	"./cs/paymentModal.json": 57235,
	"./cs/paymentStatuses.json": 81976,
	"./cs/paymentTypes.json": 11483,
	"./cs/payments.json": 6907,
	"./cs/pos.json": 76714,
	"./cs/price.json": 91861,
	"./cs/priceComparison.json": 73760,
	"./cs/problemCategory.json": 80727,
	"./cs/problems.json": 70928,
	"./cs/productHistory.json": 19505,
	"./cs/productionPriority.json": 56511,
	"./cs/productionSettings.json": 85358,
	"./cs/products.json": 61656,
	"./cs/purchasePrices.json": 91293,
	"./cs/receipt.json": 31016,
	"./cs/receiptModal.json": 4317,
	"./cs/receiveMoney.json": 74347,
	"./cs/refundMoney.json": 30154,
	"./cs/regionRules.json": 63255,
	"./cs/register.json": 36777,
	"./cs/relatedGroups.json": 29855,
	"./cs/returnSettings.json": 7711,
	"./cs/rightSidebar.json": 31830,
	"./cs/salesCollectList.json": 4942,
	"./cs/salesModule.json": 89564,
	"./cs/salesProductList.json": 24835,
	"./cs/saveBar.json": 21714,
	"./cs/scanModal.json": 55098,
	"./cs/serialNumbers.json": 7890,
	"./cs/session.json": 8240,
	"./cs/setNewPassword.json": 73439,
	"./cs/settings.json": 63413,
	"./cs/settingsHome.json": 40670,
	"./cs/settingsLists.json": 66438,
	"./cs/settingsViews.json": 92313,
	"./cs/stateTypes.json": 31482,
	"./cs/stockValue.json": 46579,
	"./cs/tags.json": 55753,
	"./cs/textAndFiles.json": 25139,
	"./cs/textAndFilesModal.json": 84452,
	"./cs/tickets.json": 87341,
	"./cs/topBar.json": 89752,
	"./cs/uploadImage.json": 59486,
	"./cs/uploadVideo.json": 19164,
	"./cs/users.json": 8303,
	"./cs/vatRates.json": 84186,
	"./cs/videos.json": 38236,
	"./cs/warehouseEdit.json": 10003,
	"./cs/warehouses.json": 43612,
	"./cs/webshops.json": 88695,
	"./cs/work.json": 21205,
	"./cs/wysiwygModal.json": 64534,
	"./de/acceptLogin.json": 96384,
	"./de/account.json": 93582,
	"./de/addNewContactsModal.json": 16526,
	"./de/addNewIntegration.json": 49570,
	"./de/addRole.json": 70070,
	"./de/address.json": 65889,
	"./de/addressFields.json": 34292,
	"./de/addresses.json": 2549,
	"./de/aiActions.json": 14992,
	"./de/aiSettings.json": 32220,
	"./de/aiWorkflows.json": 281,
	"./de/apiKeys.json": 68545,
	"./de/appCatalog.json": 16181,
	"./de/assetFinder.json": 19733,
	"./de/bankAccount.json": 63556,
	"./de/bankDetailsToast.json": 93968,
	"./de/barcodeReader.json": 24674,
	"./de/catalogImport.json": 82591,
	"./de/catalogLastLog.json": 5284,
	"./de/cataloge.json": 49697,
	"./de/categories.json": 56547,
	"./de/categoryModal.json": 18460,
	"./de/channels.json": 20919,
	"./de/characteristicsModal.json": 2864,
	"./de/chart1.json": 98728,
	"./de/collectionSettings.json": 24782,
	"./de/companies.json": 35498,
	"./de/companyEdit.json": 69470,
	"./de/confirmModal.json": 12262,
	"./de/contactsModal.json": 49255,
	"./de/copyProducts.json": 1398,
	"./de/countries.json": 6055,
	"./de/couriersSettings.json": 62754,
	"./de/crm.json": 8657,
	"./de/crmItemFinder.json": 34614,
	"./de/crmPaymentPairing.json": 4483,
	"./de/crmPaymentPairingModal.json": 43572,
	"./de/crmSettings.json": 84160,
	"./de/currencies.json": 6488,
	"./de/customRowModal.json": 89117,
	"./de/customRows.json": 35581,
	"./de/customerService.json": 18954,
	"./de/datePicker.json": 22069,
	"./de/defaultWebshops.json": 73531,
	"./de/deliveredStatuses.json": 93887,
	"./de/deliveries.json": 94471,
	"./de/deliveriesModal.json": 9600,
	"./de/deliveryCountriesSetting.json": 44329,
	"./de/deliveryDetails.json": 35111,
	"./de/deliveryStatusModal.json": 78846,
	"./de/deliveryTrackingStatuses.json": 16240,
	"./de/denyOrder.json": 29623,
	"./de/domains.json": 48288,
	"./de/editDeliveryModal.json": 82164,
	"./de/editOnClick.json": 66906,
	"./de/editOrderProductsModal.json": 7578,
	"./de/editUser.json": 16352,
	"./de/events.json": 5678,
	"./de/externalCategoriesModal.json": 72789,
	"./de/files.json": 77994,
	"./de/filesModal.json": 27743,
	"./de/filesWithLabel.json": 34832,
	"./de/filters.json": 26778,
	"./de/finance.json": 96099,
	"./de/first.json": 16763,
	"./de/forgottenPassword.json": 45262,
	"./de/fraudRisk.json": 98024,
	"./de/generalSettings.json": 22008,
	"./de/global.json": 71188,
	"./de/home.json": 82444,
	"./de/imageEditor.json": 53825,
	"./de/imageUpload.json": 67513,
	"./de/incomeSettings.json": 96157,
	"./de/incomeStatement.json": 87837,
	"./de/incomingItemsStatuses.json": 43547,
	"./de/incomingProducts.json": 24119,
	"./de/incomingstatuses.json": 40281,
	"./de/ingredients.json": 71349,
	"./de/integrationAuth.json": 35813,
	"./de/integrationSettingsModal.json": 96275,
	"./de/integrations.json": 17244,
	"./de/inventoryAnalytics.json": 63343,
	"./de/invoice.json": 32042,
	"./de/invoiceData.json": 26938,
	"./de/invoiceDetails.json": 25972,
	"./de/invoiceModal.json": 80383,
	"./de/itemOperationPrints.json": 60745,
	"./de/itemOperationTypes.json": 2802,
	"./de/knowledgeBase.json": 34472,
	"./de/labels.json": 73924,
	"./de/languages.json": 914,
	"./de/leftSidebar.json": 76254,
	"./de/lineOptions.json": 20865,
	"./de/login.json": 25804,
	"./de/manualIncoming.json": 37049,
	"./de/manufacturingCollectList.json": 90863,
	"./de/manufacturingDailyList.json": 79952,
	"./de/manufacturingDesigner.json": 32198,
	"./de/manufacturingGrant.json": 74315,
	"./de/manufacturingMaterials.json": 85395,
	"./de/manufacturingModal.json": 86036,
	"./de/manufacturingOperationsModal.json": 98366,
	"./de/manufacturingWorkstation.json": 30350,
	"./de/menu.json": 76200,
	"./de/messages.json": 23447,
	"./de/meta.json": 46246,
	"./de/modal.json": 73720,
	"./de/nested.json": 3620,
	"./de/newAssets.json": 65506,
	"./de/newCustomer.json": 88379,
	"./de/newManualIncoming.json": 40201,
	"./de/newManufacturingOperation.json": 37024,
	"./de/newMember.json": 44545,
	"./de/newOutgoing.json": 80965,
	"./de/newPartner.json": 92347,
	"./de/newSale.json": 8500,
	"./de/notifications.json": 84181,
	"./de/oneByOneTable.json": 64788,
	"./de/operationBoard.json": 87228,
	"./de/operationPage.json": 13031,
	"./de/order.json": 7357,
	"./de/orderAfterStatus.json": 8359,
	"./de/orderButtons.json": 56878,
	"./de/orderChange.json": 42325,
	"./de/orderMultiplePayment.json": 38637,
	"./de/orderPayment.json": 10273,
	"./de/orderProducts.json": 54789,
	"./de/orderStatuses.json": 86203,
	"./de/outgoing.json": 62357,
	"./de/packingSettings.json": 39899,
	"./de/page.json": 87508,
	"./de/password.json": 1618,
	"./de/paymentModal.json": 16076,
	"./de/paymentStatuses.json": 75429,
	"./de/paymentTypes.json": 41672,
	"./de/payments.json": 38912,
	"./de/pos.json": 12367,
	"./de/price.json": 33856,
	"./de/priceComparison.json": 9813,
	"./de/problemCategory.json": 26074,
	"./de/problems.json": 49215,
	"./de/productHistory.json": 16074,
	"./de/productionPriority.json": 15216,
	"./de/productionSettings.json": 11145,
	"./de/products.json": 75591,
	"./de/purchasePrices.json": 8158,
	"./de/receipt.json": 79053,
	"./de/receiptModal.json": 95862,
	"./de/receiveMoney.json": 43464,
	"./de/refundMoney.json": 97263,
	"./de/regionRules.json": 5330,
	"./de/register.json": 43230,
	"./de/relatedGroups.json": 15838,
	"./de/returnSettings.json": 71872,
	"./de/rightSidebar.json": 36569,
	"./de/salesCollectList.json": 697,
	"./de/salesModule.json": 44137,
	"./de/salesProductList.json": 23412,
	"./de/saveBar.json": 83371,
	"./de/scanModal.json": 7031,
	"./de/serialNumbers.json": 95219,
	"./de/session.json": 87365,
	"./de/setNewPassword.json": 45708,
	"./de/settings.json": 62326,
	"./de/settingsHome.json": 76945,
	"./de/settingsLists.json": 9319,
	"./de/settingsViews.json": 58728,
	"./de/stateTypes.json": 56821,
	"./de/stockValue.json": 1864,
	"./de/tags.json": 44094,
	"./de/textAndFiles.json": 17580,
	"./de/textAndFilesModal.json": 82505,
	"./de/tickets.json": 26228,
	"./de/topBar.json": 45239,
	"./de/uploadImage.json": 92759,
	"./de/uploadVideo.json": 25053,
	"./de/users.json": 15833,
	"./de/vatRates.json": 39089,
	"./de/videos.json": 73019,
	"./de/warehouseEdit.json": 54690,
	"./de/warehouses.json": 14875,
	"./de/webshops.json": 72016,
	"./de/work.json": 25542,
	"./de/wysiwygModal.json": 52349,
	"./en/acceptLogin.json": 49736,
	"./en/account.json": 87926,
	"./en/addNewContactsModal.json": 52310,
	"./en/addNewIntegration.json": 76266,
	"./en/addRole.json": 15998,
	"./en/address.json": 48406,
	"./en/addressFields.json": 91228,
	"./en/addresses.json": 28989,
	"./en/aiActions.json": 56600,
	"./en/aiChat.json": 51943,
	"./en/aiSettings.json": 2084,
	"./en/aiWorkflows.json": 25201,
	"./en/apiKeys.json": 30905,
	"./en/appCatalog.json": 86573,
	"./en/assetFinder.json": 24509,
	"./en/bankAccount.json": 49580,
	"./en/bankDetailsToast.json": 72792,
	"./en/barcodeReader.json": 55706,
	"./en/cashflowTypes.json": 43769,
	"./en/catalogImport.json": 86199,
	"./en/catalogLastLog.json": 41036,
	"./en/cataloge.json": 37145,
	"./en/categories.json": 40251,
	"./en/categoryModal.json": 11732,
	"./en/channels.json": 63599,
	"./en/characteristicsModal.json": 1192,
	"./en/chart1.json": 13552,
	"./en/collectionSettings.json": 93638,
	"./en/companies.json": 77426,
	"./en/companyEdit.json": 79990,
	"./en/confirmModal.json": 10830,
	"./en/consignment.json": 42056,
	"./en/consignmentSettlements.json": 22232,
	"./en/contactsModal.json": 98975,
	"./en/copyProducts.json": 94078,
	"./en/countries.json": 30847,
	"./en/couriersSettings.json": 57050,
	"./en/crm.json": 66921,
	"./en/crmItemFinder.json": 56270,
	"./en/crmPaymentPairing.json": 75707,
	"./en/crmPaymentPairingModal.json": 87628,
	"./en/crmSettings.json": 94328,
	"./en/currencies.json": 86032,
	"./en/customRowModal.json": 61461,
	"./en/customRows.json": 15205,
	"./en/customerProfile.json": 64588,
	"./en/customerService.json": 90658,
	"./en/dashboardBlocks.json": 87935,
	"./en/datePicker.json": 52941,
	"./en/defaultWebshops.json": 51219,
	"./en/deliveredStatuses.json": 17319,
	"./en/deliveries.json": 19247,
	"./en/deliveriesModal.json": 70792,
	"./en/deliveryCountriesSetting.json": 88961,
	"./en/deliveryDetails.json": 47327,
	"./en/deliveryProblems.json": 14479,
	"./en/deliveryStatusModal.json": 42694,
	"./en/deliveryTrackingStatuses.json": 65736,
	"./en/denyOrder.json": 57967,
	"./en/domains.json": 63944,
	"./en/editDeliveryModal.json": 93484,
	"./en/editOnClick.json": 35362,
	"./en/editOrderProductsModal.json": 434,
	"./en/editUser.json": 42216,
	"./en/events.json": 5238,
	"./en/externalCategoriesModal.json": 52733,
	"./en/files.json": 73970,
	"./en/filesModal.json": 67559,
	"./en/filesWithLabel.json": 7688,
	"./en/filters.json": 81282,
	"./en/finance.json": 12795,
	"./en/financeCells.json": 9204,
	"./en/financeOverview.json": 96204,
	"./en/first.json": 13235,
	"./en/firstSteps.json": 31498,
	"./en/forecast.json": 63938,
	"./en/forgottenPassword.json": 39222,
	"./en/fraudRisk.json": 75024,
	"./en/generalSettings.json": 26784,
	"./en/global.json": 27004,
	"./en/home.json": 79028,
	"./en/imageEditor.json": 50537,
	"./en/imageUpload.json": 47969,
	"./en/incomeSettings.json": 61429,
	"./en/incomeStatement.json": 19877,
	"./en/incomingItemsStatuses.json": 63395,
	"./en/incomingProducts.json": 63295,
	"./en/incomingstatuses.json": 58321,
	"./en/indexing.json": 85619,
	"./en/ingredients.json": 90493,
	"./en/integrationAuth.json": 51469,
	"./en/integrationSettingsModal.json": 45867,
	"./en/integrations.json": 90756,
	"./en/inventoryAnalytics.json": 6295,
	"./en/inventoryAudit.json": 34004,
	"./en/invoice.json": 91410,
	"./en/invoiceData.json": 72930,
	"./en/invoiceDetails.json": 80012,
	"./en/invoiceDetailsModal.json": 8073,
	"./en/invoiceModal.json": 52039,
	"./en/invoicesPage.json": 70564,
	"./en/itemOperationPrints.json": 45169,
	"./en/itemOperationTypes.json": 52058,
	"./en/knowledgeBase.json": 65136,
	"./en/labels.json": 14428,
	"./en/languages.json": 15322,
	"./en/leftSidebar.json": 5862,
	"./en/lineOptions.json": 14393,
	"./en/login.json": 53908,
	"./en/manualIncoming.json": 59598,
	"./en/manufacturingCollectList.json": 57847,
	"./en/manufacturingDailyList.json": 56696,
	"./en/manufacturingDesigner.json": 60430,
	"./en/manufacturingGrant.json": 60467,
	"./en/manufacturingMaterials.json": 9947,
	"./en/manufacturingModal.json": 83612,
	"./en/manufacturingOperationsModal.json": 40678,
	"./en/manufacturingWorkstation.json": 75542,
	"./en/menu.json": 71744,
	"./en/messages.json": 32671,
	"./en/meta.json": 59566,
	"./en/modal.json": 19312,
	"./en/nested.json": 36460,
	"./en/newAssets.json": 57882,
	"./en/newCustomer.json": 4403,
	"./en/newManualIncoming.json": 73777,
	"./en/newManufacturingOperation.json": 77272,
	"./en/newMember.json": 97945,
	"./en/newOutgoing.json": 68669,
	"./en/newPartner.json": 29011,
	"./en/newSale.json": 70812,
	"./en/notifications.json": 28781,
	"./en/oneByOneTable.json": 95228,
	"./en/operationBoard.json": 67396,
	"./en/operationFinance.json": 42790,
	"./en/operationPage.json": 33871,
	"./en/order.json": 61717,
	"./en/orderAfterStatus.json": 31215,
	"./en/orderButtons.json": 73622,
	"./en/orderChange.json": 72781,
	"./en/orderMultiplePayment.json": 17349,
	"./en/orderPayment.json": 83321,
	"./en/orderProducts.json": 58957,
	"./en/orderStatuses.json": 71571,
	"./en/outgoing.json": 13197,
	"./en/packingSettings.json": 35667,
	"./en/page.json": 99884,
	"./en/pairPaymentModal.json": 13684,
	"./en/partnerDetails.json": 18363,
	"./en/password.json": 1594,
	"./en/paymentModal.json": 10116,
	"./en/paymentStatuses.json": 63613,
	"./en/paymentTypes.json": 3968,
	"./en/payments.json": 14024,
	"./en/pos.json": 56487,
	"./en/price.json": 34552,
	"./en/priceComparison.json": 45469,
	"./en/problemCategory.json": 94322,
	"./en/problems.json": 97479,
	"./en/productForecast.json": 10367,
	"./en/productHistory.json": 17714,
	"./en/productionPriority.json": 50600,
	"./en/productionSettings.json": 66145,
	"./en/products.json": 10543,
	"./en/purchasePrices.json": 85942,
	"./en/purchasing.json": 20531,
	"./en/receipt.json": 62917,
	"./en/receiptModal.json": 59246,
	"./en/receiveMoney.json": 73776,
	"./en/refundMoney.json": 14919,
	"./en/regionRules.json": 99514,
	"./en/register.json": 1350,
	"./en/relatedGroups.json": 78566,
	"./en/returnSettings.json": 82952,
	"./en/rightSidebar.json": 3777,
	"./en/salesCollectList.json": 98289,
	"./en/salesModule.json": 34417,
	"./en/salesProductList.json": 59148,
	"./en/saveBar.json": 32595,
	"./en/scanModal.json": 89983,
	"./en/serialNumbers.json": 35707,
	"./en/session.json": 68253,
	"./en/setNewPassword.json": 40420,
	"./en/settings.json": 68686,
	"./en/settingsHome.json": 59430,
	"./en/settingsLists.json": 96559,
	"./en/settingsModal.json": 49691,
	"./en/settingsViews.json": 85920,
	"./en/shelfMove.json": 79408,
	"./en/spendDetails.json": 63973,
	"./en/spending.json": 42911,
	"./en/stateTypes.json": 26045,
	"./en/stockLocation.json": 1196,
	"./en/stockValue.json": 79344,
	"./en/tags.json": 75318,
	"./en/textAndFiles.json": 19940,
	"./en/textAndFilesModal.json": 46369,
	"./en/tickets.json": 57948,
	"./en/topBar.json": 55231,
	"./en/trolleys.json": 79417,
	"./en/uploadImage.json": 26847,
	"./en/uploadVideo.json": 86693,
	"./en/users.json": 53377,
	"./en/variantFilters.json": 19515,
	"./en/vatRates.json": 87817,
	"./en/videos.json": 92179,
	"./en/warehouseEdit.json": 79962,
	"./en/warehouses.json": 98963,
	"./en/webshopPayments.json": 37636,
	"./en/webshops.json": 91272,
	"./en/work.json": 18686,
	"./en/wysiwygModal.json": 43061,
	"./hu/acceptLogin.json": 89836,
	"./hu/account.json": 74570,
	"./hu/addNewContactsModal.json": 93026,
	"./hu/addNewIntegration.json": 98318,
	"./hu/addRole.json": 96890,
	"./hu/address.json": 40981,
	"./hu/addressFields.json": 26568,
	"./hu/addresses.json": 51729,
	"./hu/aiActions.json": 84324,
	"./hu/aiChat.json": 70555,
	"./hu/aiSettings.json": 5896,
	"./hu/aiWorkflows.json": 12181,
	"./hu/apiKeys.json": 23317,
	"./hu/appCatalog.json": 6489,
	"./hu/assetFinder.json": 18593,
	"./hu/bankAccount.json": 61128,
	"./hu/bankDetailsToast.json": 13156,
	"./hu/barcodeReader.json": 62318,
	"./hu/cashflowTypes.json": 98989,
	"./hu/catalogImport.json": 24611,
	"./hu/catalogLastLog.json": 22896,
	"./hu/cataloge.json": 42045,
	"./hu/categories.json": 88463,
	"./hu/categoryModal.json": 48488,
	"./hu/channels.json": 9179,
	"./hu/characteristicsModal.json": 61740,
	"./hu/chart1.json": 24260,
	"./hu/collectionSettings.json": 66290,
	"./hu/companies.json": 62054,
	"./hu/companyEdit.json": 30346,
	"./hu/confirmModal.json": 71706,
	"./hu/consignment.json": 42940,
	"./hu/consignmentSettlements.json": 74796,
	"./hu/contactsModal.json": 41795,
	"./hu/copyProducts.json": 88546,
	"./hu/countries.json": 80667,
	"./hu/couriersSettings.json": 1638,
	"./hu/crm.json": 49605,
	"./hu/crmItemFinder.json": 56258,
	"./hu/crmPaymentPairing.json": 215,
	"./hu/crmPaymentPairingModal.json": 90000,
	"./hu/crmSettings.json": 86124,
	"./hu/currencies.json": 40604,
	"./hu/customRowModal.json": 51041,
	"./hu/customRows.json": 30769,
	"./hu/customerProfile.json": 44984,
	"./hu/customerService.json": 74214,
	"./hu/dashboardBlocks.json": 87963,
	"./hu/datePicker.json": 86761,
	"./hu/defaultWebshops.json": 37327,
	"./hu/deliveredStatuses.json": 69411,
	"./hu/deliveries.json": 66747,
	"./hu/deliveriesModal.json": 58988,
	"./hu/deliveryCountriesSetting.json": 22325,
	"./hu/deliveryDetails.json": 13755,
	"./hu/deliveryProblems.json": 10739,
	"./hu/deliveryStatusModal.json": 21210,
	"./hu/deliveryTrackingStatuses.json": 22148,
	"./hu/denyOrder.json": 51875,
	"./hu/domains.json": 58252,
	"./hu/editDeliveryModal.json": 8272,
	"./hu/editOnClick.json": 17062,
	"./hu/editUser.json": 66668,
	"./hu/events.json": 90378,
	"./hu/externalCategoriesModal.json": 17729,
	"./hu/files.json": 11566,
	"./hu/filesModal.json": 13851,
	"./hu/filesWithLabel.json": 18356,
	"./hu/filters.json": 92614,
	"./hu/finance.json": 1439,
	"./hu/financeCells.json": 28248,
	"./hu/financeOverview.json": 22928,
	"./hu/first.json": 32343,
	"./hu/firstSteps.json": 78662,
	"./hu/forecast.json": 84622,
	"./hu/forgottenPassword.json": 61445,
	"./hu/fraudRisk.json": 66412,
	"./hu/generalSettings.json": 32180,
	"./hu/global.json": 15096,
	"./hu/home.json": 78984,
	"./hu/imageEditor.json": 99861,
	"./hu/imageUpload.json": 32637,
	"./hu/incomeSettings.json": 18489,
	"./hu/incomeStatement.json": 28497,
	"./hu/incomingItemsStatuses.json": 34631,
	"./hu/incomingProducts.json": 40883,
	"./hu/incomingstatuses.json": 56293,
	"./hu/indexing.json": 24503,
	"./hu/ingredients.json": 53641,
	"./hu/integrationAuth.json": 69337,
	"./hu/integrationSettingsModal.json": 38455,
	"./hu/integrations.json": 29000,
	"./hu/inventoryAnalytics.json": 80459,
	"./hu/inventoryAudit.json": 48072,
	"./hu/invoice.json": 20102,
	"./hu/invoiceData.json": 88646,
	"./hu/invoiceDetails.json": 17464,
	"./hu/invoiceDetailsModal.json": 32685,
	"./hu/invoiceModal.json": 49427,
	"./hu/invoicesPage.json": 6352,
	"./hu/itemOperationPrints.json": 65925,
	"./hu/itemOperationTypes.json": 81078,
	"./hu/knowledgeBase.json": 10396,
	"./hu/labels.json": 55184,
	"./hu/languages.json": 99966,
	"./hu/leftSidebar.json": 86154,
	"./hu/lineOptions.json": 36357,
	"./hu/login.json": 21576,
	"./hu/manualIncoming.json": 52933,
	"./hu/manufacturingCollectList.json": 99451,
	"./hu/manufacturingDailyList.json": 61988,
	"./hu/manufacturingDesigner.json": 8538,
	"./hu/manufacturingGrant.json": 62775,
	"./hu/manufacturingMaterials.json": 58551,
	"./hu/manufacturingModal.json": 98888,
	"./hu/manufacturingOperationsModal.json": 83978,
	"./hu/manufacturingWorkstation.json": 55538,
	"./hu/menu.json": 59788,
	"./hu/messages.json": 80027,
	"./hu/meta.json": 37810,
	"./hu/modal.json": 49748,
	"./hu/nested.json": 7648,
	"./hu/newAssets.json": 2662,
	"./hu/newCustomer.json": 63575,
	"./hu/newManualIncoming.json": 80805,
	"./hu/newManufacturingOperation.json": 83180,
	"./hu/newMember.json": 48597,
	"./hu/newOutgoing.json": 10769,
	"./hu/newPartner.json": 70911,
	"./hu/newSale.json": 44824,
	"./hu/notifications.json": 39033,
	"./hu/oneByOneTable.json": 24904,
	"./hu/operationBoard.json": 76664,
	"./hu/operationFinance.json": 13434,
	"./hu/operationPage.json": 74715,
	"./hu/order.json": 71041,
	"./hu/orderAfterStatus.json": 96419,
	"./hu/orderButtons.json": 53794,
	"./hu/orderChange.json": 84353,
	"./hu/orderMultiplePayment.json": 70697,
	"./hu/orderPayment.json": 6973,
	"./hu/orderProducts.json": 22681,
	"./hu/orderStatuses.json": 86879,
	"./hu/outgoing.json": 1553,
	"./hu/packingSettings.json": 90159,
	"./hu/page.json": 49656,
	"./hu/pairPaymentModal.json": 10848,
	"./hu/partnerDetails.json": 42351,
	"./hu/password.json": 91198,
	"./hu/paymentModal.json": 44784,
	"./hu/paymentStatuses.json": 52577,
	"./hu/paymentTypes.json": 45004,
	"./hu/payments.json": 35572,
	"./hu/pos.json": 56675,
	"./hu/price.json": 84724,
	"./hu/priceComparison.json": 40537,
	"./hu/problemCategory.json": 33286,
	"./hu/problems.json": 91187,
	"./hu/productForecast.json": 25331,
	"./hu/productHistory.json": 55406,
	"./hu/productionPriority.json": 90820,
	"./hu/productionSettings.json": 62965,
	"./hu/products.json": 95147,
	"./hu/purchasePrices.json": 84858,
	"./hu/purchasing.json": 95383,
	"./hu/receipt.json": 66497,
	"./hu/receiptModal.json": 6402,
	"./hu/receiveMoney.json": 58508,
	"./hu/refundMoney.json": 32371,
	"./hu/regionRules.json": 90966,
	"./hu/register.json": 54578,
	"./hu/relatedGroups.json": 59178,
	"./hu/returnSettings.json": 45756,
	"./hu/rightSidebar.json": 96701,
	"./hu/salesCollectList.json": 77170,
	"./hu/salesModule.json": 11685,
	"./hu/salesProductList.json": 19864,
	"./hu/saveBar.json": 32327,
	"./hu/scanModal.json": 26363,
	"./hu/serialNumbers.json": 76927,
	"./hu/session.json": 70201,
	"./hu/setNewPassword.json": 11840,
	"./hu/settings.json": 46194,
	"./hu/settingsHome.json": 55237,
	"./hu/settingsLists.json": 31051,
	"./hu/settingsModal.json": 91111,
	"./hu/settingsViews.json": 36532,
	"./hu/shelfMove.json": 1164,
	"./hu/spendDetails.json": 25881,
	"./hu/spending.json": 96435,
	"./hu/stateTypes.json": 68993,
	"./hu/stockLocation.json": 77432,
	"./hu/stockValue.json": 57612,
	"./hu/tags.json": 8978,
	"./hu/textAndFiles.json": 29456,
	"./hu/textAndFilesModal.json": 37221,
	"./hu/tickets.json": 93592,
	"./hu/topBar.json": 94731,
	"./hu/trolleys.json": 58298,
	"./hu/uploadImage.json": 18219,
	"./hu/uploadVideo.json": 83225,
	"./hu/users.json": 70661,
	"./hu/variantFilters.json": 65759,
	"./hu/vatRates.json": 43893,
	"./hu/videos.json": 99679,
	"./hu/warehouseEdit.json": 32494,
	"./hu/warehouses.json": 56183,
	"./hu/webshopPayments.json": 58672,
	"./hu/webshops.json": 20252,
	"./hu/work.json": 4714,
	"./hu/wysiwygModal.json": 3977,
	"./ro/acceptLogin.json": 89332,
	"./ro/account.json": 27346,
	"./ro/addNewContactsModal.json": 96106,
	"./ro/addNewIntegration.json": 96630,
	"./ro/addRole.json": 64642,
	"./ro/address.json": 22781,
	"./ro/addressFields.json": 68816,
	"./ro/addresses.json": 45017,
	"./ro/aiActions.json": 94764,
	"./ro/aiSettings.json": 92272,
	"./ro/aiWorkflows.json": 31469,
	"./ro/apiKeys.json": 34509,
	"./ro/appCatalog.json": 41969,
	"./ro/assetFinder.json": 38953,
	"./ro/bankAccount.json": 76336,
	"./ro/bankDetailsToast.json": 5516,
	"./ro/barcodeReader.json": 83590,
	"./ro/catalogImport.json": 43291,
	"./ro/catalogLastLog.json": 55384,
	"./ro/cataloge.json": 57909,
	"./ro/categories.json": 59687,
	"./ro/categoryModal.json": 35744,
	"./ro/channels.json": 3891,
	"./ro/characteristicsModal.json": 61284,
	"./ro/chart1.json": 73068,
	"./ro/collectionSettings.json": 99306,
	"./ro/companies.json": 83694,
	"./ro/companyEdit.json": 73858,
	"./ro/confirmModal.json": 56290,
	"./ro/contactsModal.json": 82811,
	"./ro/copyProducts.json": 36202,
	"./ro/countries.json": 99123,
	"./ro/couriersSettings.json": 11902,
	"./ro/crm.json": 12413,
	"./ro/crmItemFinder.json": 9146,
	"./ro/crmPaymentPairing.json": 87791,
	"./ro/crmPaymentPairingModal.json": 30280,
	"./ro/crmSettings.json": 16132,
	"./ro/currencies.json": 75572,
	"./ro/customRowModal.json": 39449,
	"./ro/customRows.json": 67609,
	"./ro/customerService.json": 27166,
	"./ro/datePicker.json": 51265,
	"./ro/defaultWebshops.json": 55399,
	"./ro/deliveredStatuses.json": 37835,
	"./ro/deliveries.json": 58915,
	"./ro/deliveriesModal.json": 70484,
	"./ro/deliveryCountriesSetting.json": 26893,
	"./ro/deliveryDetails.json": 97235,
	"./ro/deliveryStatusModal.json": 3010,
	"./ro/deliveryTrackingStatuses.json": 66364,
	"./ro/denyOrder.json": 78299,
	"./ro/domains.json": 99348,
	"./ro/editDeliveryModal.json": 77576,
	"./ro/editOnClick.json": 32110,
	"./ro/editOrderProductsModal.json": 6102,
	"./ro/editUser.json": 28084,
	"./ro/events.json": 65714,
	"./ro/externalCategoriesModal.json": 83593,
	"./ro/files.json": 4822,
	"./ro/filesModal.json": 57667,
	"./ro/filesWithLabel.json": 83135,
	"./ro/filters.json": 50766,
	"./ro/finance.json": 41015,
	"./ro/first.json": 78511,
	"./ro/forgottenPassword.json": 5722,
	"./ro/fraudRisk.json": 37684,
	"./ro/generalSettings.json": 48508,
	"./ro/global.json": 37312,
	"./ro/home.json": 27696,
	"./ro/imageEditor.json": 98141,
	"./ro/imageUpload.json": 51269,
	"./ro/incomeSettings.json": 61873,
	"./ro/incomeStatement.json": 32601,
	"./ro/incomingItemsStatuses.json": 21167,
	"./ro/incomingProducts.json": 83099,
	"./ro/incomingstatuses.json": 49757,
	"./ro/indexing.json": 77023,
	"./ro/ingredients.json": 78385,
	"./ro/integrationAuth.json": 9857,
	"./ro/integrationSettingsModal.json": 54063,
	"./ro/integrations.json": 83280,
	"./ro/inventoryAnalytics.json": 45139,
	"./ro/invoice.json": 76046,
	"./ro/invoiceData.json": 96942,
	"./ro/invoiceDetails.json": 77520,
	"./ro/invoiceModal.json": 7451,
	"./ro/itemOperationPrints.json": 25101,
	"./ro/itemOperationTypes.json": 55134,
	"./ro/knowledgeBase.json": 12804,
	"./ro/labels.json": 33000,
	"./ro/languages.json": 35494,
	"./ro/leftSidebar.json": 19698,
	"./ro/lineOptions.json": 15453,
	"./ro/login.json": 94160,
	"./ro/manualIncoming.json": 6093,
	"./ro/manufacturingCollectList.json": 87427,
	"./ro/manufacturingDailyList.json": 33452,
	"./ro/manufacturingDesigner.json": 74658,
	"./ro/manufacturingGrant.json": 86271,
	"./ro/manufacturingMaterials.json": 48799,
	"./ro/manufacturingModal.json": 32080,
	"./ro/manufacturingOperationsModal.json": 8850,
	"./ro/manufacturingWorkstation.json": 53178,
	"./ro/menu.json": 9924,
	"./ro/messages.json": 53219,
	"./ro/meta.json": 18938,
	"./ro/modal.json": 33964,
	"./ro/nested.json": 31144,
	"./ro/newAssets.json": 92990,
	"./ro/newCustomer.json": 97391,
	"./ro/newManualIncoming.json": 60205,
	"./ro/newManufacturingOperation.json": 8868,
	"./ro/newMember.json": 39629,
	"./ro/newOutgoing.json": 99369,
	"./ro/newPartner.json": 91735,
	"./ro/newSale.json": 7104,
	"./ro/notifications.json": 34225,
	"./ro/oneByOneTable.json": 79536,
	"./ro/operationBoard.json": 49664,
	"./ro/operationPage.json": 41347,
	"./ro/order.json": 39801,
	"./ro/orderAfterStatus.json": 12075,
	"./ro/orderButtons.json": 99018,
	"./ro/orderChange.json": 50681,
	"./ro/orderMultiplePayment.json": 57057,
	"./ro/orderPayment.json": 36629,
	"./ro/orderProducts.json": 83265,
	"./ro/orderStatuses.json": 4599,
	"./ro/outgoing.json": 95753,
	"./ro/packingSettings.json": 96231,
	"./ro/page.json": 11056,
	"./ro/password.json": 40166,
	"./ro/paymentModal.json": 10792,
	"./ro/paymentStatuses.json": 35257,
	"./ro/paymentTypes.json": 49828,
	"./ro/payments.json": 74684,
	"./ro/pos.json": 17307,
	"./ro/price.json": 82892,
	"./ro/priceComparison.json": 42017,
	"./ro/problemCategory.json": 9662,
	"./ro/problems.json": 92571,
	"./ro/productHistory.json": 50806,
	"./ro/productionPriority.json": 40284,
	"./ro/productionSettings.json": 17293,
	"./ro/products.json": 87827,
	"./ro/purchasePrices.json": 90610,
	"./ro/receipt.json": 2201,
	"./ro/receiptModal.json": 39834,
	"./ro/receiveMoney.json": 64020,
	"./ro/refundMoney.json": 13867,
	"./ro/regionRules.json": 32350,
	"./ro/register.json": 70426,
	"./ro/relatedGroups.json": 8530,
	"./ro/returnSettings.json": 13604,
	"./ro/rightSidebar.json": 23333,
	"./ro/salesCollectList.json": 87965,
	"./ro/salesModule.json": 49581,
	"./ro/salesProductList.json": 16176,
	"./ro/saveBar.json": 39855,
	"./ro/scanModal.json": 67459,
	"./ro/serialNumbers.json": 65671,
	"./ro/session.json": 49489,
	"./ro/setNewPassword.json": 74648,
	"./ro/settings.json": 87466,
	"./ro/settingsHome.json": 47117,
	"./ro/settingsLists.json": 5651,
	"./ro/settingsViews.json": 8076,
	"./ro/stateTypes.json": 58505,
	"./ro/stockValue.json": 34708,
	"./ro/tags.json": 938,
	"./ro/textAndFiles.json": 26952,
	"./ro/textAndFilesModal.json": 88285,
	"./ro/tickets.json": 23904,
	"./ro/topBar.json": 53427,
	"./ro/uploadImage.json": 31059,
	"./ro/uploadVideo.json": 12961,
	"./ro/users.json": 14093,
	"./ro/vatRates.json": 42477,
	"./ro/videos.json": 97815,
	"./ro/warehouseEdit.json": 64838,
	"./ro/warehouses.json": 96335,
	"./ro/webshops.json": 89428,
	"./ro/work.json": 23074,
	"./ro/wysiwygModal.json": 81825,
	"./sk/acceptLogin.json": 76421,
	"./sk/account.json": 46491,
	"./sk/addNewContactsModal.json": 62383,
	"./sk/addNewIntegration.json": 35319,
	"./sk/addRole.json": 81219,
	"./sk/address.json": 12596,
	"./sk/addressFields.json": 42525,
	"./sk/addresses.json": 28464,
	"./sk/aiActions.json": 79941,
	"./sk/aiSettings.json": 55343,
	"./sk/aiWorkflows.json": 57008,
	"./sk/apiKeys.json": 40368,
	"./sk/appCatalog.json": 45718,
	"./sk/assetFinder.json": 90044,
	"./sk/bankAccount.json": 31289,
	"./sk/bankDetailsToast.json": 22167,
	"./sk/barcodeReader.json": 51003,
	"./sk/catalogImport.json": 38590,
	"./sk/catalogLastLog.json": 84587,
	"./sk/cataloge.json": 66270,
	"./sk/categories.json": 43016,
	"./sk/categoryModal.json": 59545,
	"./sk/channels.json": 41388,
	"./sk/characteristicsModal.json": 30991,
	"./sk/chart1.json": 37855,
	"./sk/collectionSettings.json": 69177,
	"./sk/companies.json": 65672,
	"./sk/companyEdit.json": 49807,
	"./sk/confirmModal.json": 63681,
	"./sk/contactsModal.json": 70246,
	"./sk/copyProducts.json": 22885,
	"./sk/countries.json": 87986,
	"./sk/couriersSettings.json": 22989,
	"./sk/crm.json": 24368,
	"./sk/crmItemFinder.json": 12107,
	"./sk/crmPaymentPairing.json": 42902,
	"./sk/crmPaymentPairingModal.json": 5155,
	"./sk/crmSettings.json": 51345,
	"./sk/currencies.json": 5903,
	"./sk/customRowModal.json": 12890,
	"./sk/customRows.json": 19894,
	"./sk/customerService.json": 39663,
	"./sk/datePicker.json": 1678,
	"./sk/defaultWebshops.json": 71658,
	"./sk/deliveredStatuses.json": 61394,
	"./sk/deliveries.json": 82344,
	"./sk/deliveriesModal.json": 1885,
	"./sk/deliveryCountriesSetting.json": 80110,
	"./sk/deliveryDetails.json": 4670,
	"./sk/deliveryStatusModal.json": 41687,
	"./sk/deliveryTrackingStatuses.json": 13343,
	"./sk/denyOrder.json": 3826,
	"./sk/domains.json": 60669,
	"./sk/editDeliveryModal.json": 43989,
	"./sk/editOnClick.json": 16115,
	"./sk/editOrderProductsModal.json": 79873,
	"./sk/editUser.json": 49379,
	"./sk/events.json": 93833,
	"./sk/externalCategoriesModal.json": 50248,
	"./sk/files.json": 76731,
	"./sk/filesModal.json": 30444,
	"./sk/filesWithLabel.json": 29387,
	"./sk/filters.json": 96839,
	"./sk/finance.json": 84134,
	"./sk/first.json": 61054,
	"./sk/forgottenPassword.json": 24963,
	"./sk/fraudRisk.json": 58193,
	"./sk/generalSettings.json": 21637,
	"./sk/global.json": 6915,
	"./sk/home.json": 85843,
	"./sk/imageEditor.json": 67812,
	"./sk/imageUpload.json": 35552,
	"./sk/incomeSettings.json": 39342,
	"./sk/incomeStatement.json": 67324,
	"./sk/incomingItemsStatuses.json": 77346,
	"./sk/incomingProducts.json": 41244,
	"./sk/incomingstatuses.json": 47462,
	"./sk/ingredients.json": 73536,
	"./sk/integrationAuth.json": 87468,
	"./sk/integrationSettingsModal.json": 74708,
	"./sk/integrations.json": 39431,
	"./sk/inventoryAnalytics.json": 55208,
	"./sk/invoice.json": 62167,
	"./sk/invoiceData.json": 25151,
	"./sk/invoiceDetails.json": 43415,
	"./sk/invoiceModal.json": 80592,
	"./sk/itemOperationPrints.json": 63036,
	"./sk/itemOperationTypes.json": 85701,
	"./sk/knowledgeBase.json": 99113,
	"./sk/labels.json": 1251,
	"./sk/languages.json": 26927,
	"./sk/leftSidebar.json": 70239,
	"./sk/lineOptions.json": 83344,
	"./sk/login.json": 34301,
	"./sk/manualIncoming.json": 23534,
	"./sk/manufacturingCollectList.json": 75560,
	"./sk/manufacturingDailyList.json": 21595,
	"./sk/manufacturingDesigner.json": 64647,
	"./sk/manufacturingGrant.json": 60596,
	"./sk/manufacturingMaterials.json": 71355,
	"./sk/manufacturingModal.json": 51743,
	"./sk/manufacturingOperationsModal.json": 63405,
	"./sk/manufacturingWorkstation.json": 82149,
	"./sk/menu.json": 73267,
	"./sk/messages.json": 79768,
	"./sk/meta.json": 59509,
	"./sk/modal.json": 69793,
	"./sk/nested.json": 75455,
	"./sk/newAssets.json": 33071,
	"./sk/newCustomer.json": 52150,
	"./sk/newManualIncoming.json": 34256,
	"./sk/newManufacturingOperation.json": 87229,
	"./sk/newMember.json": 37228,
	"./sk/newOutgoing.json": 99644,
	"./sk/newPartner.json": 56412,
	"./sk/newSale.json": 50989,
	"./sk/notifications.json": 29792,
	"./sk/oneByOneTable.json": 63373,
	"./sk/operationBoard.json": 74947,
	"./sk/operationPage.json": 5906,
	"./sk/order.json": 98780,
	"./sk/orderAfterStatus.json": 91736,
	"./sk/orderButtons.json": 69693,
	"./sk/orderChange.json": 12468,
	"./sk/orderMultiplePayment.json": 71114,
	"./sk/orderPayment.json": 9878,
	"./sk/orderProducts.json": 99112,
	"./sk/orderStatuses.json": 71778,
	"./sk/outgoing.json": 31342,
	"./sk/packingSettings.json": 76874,
	"./sk/page.json": 34159,
	"./sk/password.json": 22193,
	"./sk/paymentModal.json": 4779,
	"./sk/paymentStatuses.json": 22000,
	"./sk/paymentTypes.json": 9267,
	"./sk/payments.json": 67363,
	"./sk/pos.json": 47842,
	"./sk/price.json": 8237,
	"./sk/priceComparison.json": 39272,
	"./sk/problemCategory.json": 93295,
	"./sk/problems.json": 86968,
	"./sk/productHistory.json": 26009,
	"./sk/productionPriority.json": 53879,
	"./sk/productionSettings.json": 64038,
	"./sk/products.json": 76160,
	"./sk/purchasePrices.json": 66101,
	"./sk/receipt.json": 384,
	"./sk/receiptModal.json": 36149,
	"./sk/receiveMoney.json": 53491,
	"./sk/refundMoney.json": 82722,
	"./sk/regionRules.json": 3167,
	"./sk/register.json": 56785,
	"./sk/relatedGroups.json": 74919,
	"./sk/returnSettings.json": 72135,
	"./sk/rightSidebar.json": 74782,
	"./sk/salesCollectList.json": 59014,
	"./sk/salesModule.json": 87300,
	"./sk/salesProductList.json": 19643,
	"./sk/saveBar.json": 58874,
	"./sk/scanModal.json": 69922,
	"./sk/serialNumbers.json": 79930,
	"./sk/session.json": 42440,
	"./sk/setNewPassword.json": 43095,
	"./sk/settings.json": 47053,
	"./sk/settingsHome.json": 26182,
	"./sk/settingsLists.json": 65070,
	"./sk/settingsViews.json": 54033,
	"./sk/stateTypes.json": 66466,
	"./sk/stockValue.json": 20859,
	"./sk/tags.json": 82881,
	"./sk/textAndFiles.json": 50763,
	"./sk/textAndFilesModal.json": 71004,
	"./sk/tickets.json": 19381,
	"./sk/topBar.json": 81568,
	"./sk/uploadImage.json": 74278,
	"./sk/uploadVideo.json": 95844,
	"./sk/users.json": 15108,
	"./sk/vatRates.json": 42834,
	"./sk/videos.json": 96788,
	"./sk/warehouseEdit.json": 86731,
	"./sk/warehouses.json": 1044,
	"./sk/webshops.json": 16079,
	"./sk/work.json": 6253,
	"./sk/wysiwygModal.json": 48526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 793;